import api from 'api';
import {
  GBP_STEPS,
  BRAND_PROPERTY,
  GBP_VERIFICATION_STATUS,
  GBP_PROPERTIES,
  PIN_GENERATION_FAILURE,
} from 'constants/gbp';
import { updateBrandProperty } from 'actions/user-brands'
import { getCurrentUserBrand } from 'selectors/user-brands';
import { fetchNotificationsAsync } from 'actions/notifications';
export const GBP_RESET_STATE = 'GBP_RESET_STATE';
export const GBP_ASYNC_ACTION_START = 'GBP_ASYNC_ACTION_START';
export const GBP_ASYNC_ACTION_ERROR_RESET = 'GBP_ASYNC_ACTION_ERROR_RESET';
export const GBP_USER_LOCATION_ASYNC_ACTION_START = 'GBP_USER_LOCATION_ASYNC_ACTION_START';
export const GBP_USER_LOCATION_ASYNC_ACTION_ERROR = 'GBP_USER_LOCATION_ASYNC_ACTION_ERROR';
export const GBP_LOCATION_VERIFICATION_ASYNC_ACTION_START = 'GBP_LOCATION_VERIFICATION_ASYNC_ACTION_START';
export const GBP_LOCATION_VERIFICATION_ASYNC_ACTION_ERROR = 'GBP_LOCATION_VERIFICATION_ASYNC_ACTION_ERROR';
export const GBP_SEARCH_LOCATIONS_SUCCESS = 'GBP_SEARCH_LOCATIONS_SUCCESS';
export const GBP_SET_MODAL_VISIBILITY = 'GBP_SET_MODAL_VISIBILITY';
export const GBP_AUTH_SUCCESS = 'GBP_AUTH_SUCCESS';
export const GBP_ALERT_VISIBILITY = 'GBP_ALERT_VISIBILITY';
export const GBP_ASYNC_SUCCESS = 'GBP_ASYNC_SUCCESS';
export const GBP_CREATE_LOCATION_SUCCESS = 'GBP_CREATE_LOCATION_SUCCESS';
export const GBP_SET_LOCATION_DATA = 'GBP_SET_LOCATION_DATA';
export const GBP_CHANGE_LOCATION_DATA = 'GBP_CHANGE_LOCATION_DATA';
export const GBP_USER_LOCATIONS_SUCCESS = 'GBP_USER_LOCATIONS_SUCCESS';
export const GBP_LOCATION_VERIFICATION_STATUS_SUCCESS = 'GBP_LOCATION_VERIFICATION_STATUS_SUCCESS';
export const GBP_RESET_LOCATION = 'GBP_RESET_LOCATION';
export const GBP_SUCCESS_ALERT = 'GBP_SUCCESS_ALERT';
export const GBP_FAILURE_ALERT = 'GBP_FAILURE_ALERT';
export const GBP_ASYNC_SEARCH_START = 'GBP_ASYNC_SEARCH_START';  
export const GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_ERROR = 'GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_ERROR';
export const GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_START = 'GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_START';
export const GBP_LOCATION_VERIFICATION_METHOD_SUCCESS = 'GBP_LOCATION_VERIFICATION_METHOD_SUCCESS';
export const GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_START = "GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_START";
export const GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_ERROR = "GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_ERROR";
export const GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_SUCCESS = "GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_SUCCESS";
export const SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_START = "SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_START";
export const SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_ERROR = "SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_ERROR";
export const SUBMIT_VERIFICATION_CODE_SUCCESS = "SUBMIT_VERIFICATION_CODE_SUCCESS";
export const GBP_ASYNC_ERROR = 'GBP_ASYNC_ERROR';

/**
 * resets gbp state
 * @returns action
 */
export const resetGbp = () => ({
  type: GBP_RESET_STATE,
});

const gbpAsyncStart = () => ({
  type: GBP_ASYNC_ACTION_START,
});


const gbpAsyncSearchStart = () => ({
  type: GBP_ASYNC_SEARCH_START,
});

const gbpAsyncErrorReset = error => ({
  type: GBP_ASYNC_ACTION_ERROR_RESET,
  error,
});

const gbpAsyncError = error => ({
  type: GBP_ASYNC_ERROR,
  error,
});

const gbpLocationVerificationAsyncStart = () => ({
  type: GBP_LOCATION_VERIFICATION_ASYNC_ACTION_START,
});

const gbpUserLocationAsyncStart = () => ({
  type: GBP_USER_LOCATION_ASYNC_ACTION_START,
});

const gbpUserLocationAsyncError = error => ({
  type: GBP_USER_LOCATION_ASYNC_ACTION_ERROR,
  error,
});

const gbpLocationVerificationMethodsAsyncStart = () => ({
  type: GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_START,
});

const gbpLocationVerificationMethodsAsyncError = error => ({
  type: GBP_LOCATION_VERIFICATION_METHOD_ASYNC_ACTION_ERROR,
  error,
});

const initiateGbpVerificationProcessAsyncStart = () => ({
  type: GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_START,
});

const initiateGbpVerificationProcessAsyncError = error => ({
  type: GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_ASYNC_ACTION_ERROR,
  error,
});

const initiateGbpVerificationProcessSuccess = (data) => {
  return {
    type: GBP_LOCATION_VERIFICATION_PROCESS_INITIATION_SUCCESS,
    payload: data,
  };
};

const submitVerificationCodeAsyncStart = () => ({
  type: SUBMIT_VERIFICATION_CODE_ASYNC_ACTION_START,
});

const submitVerificationCodeSuccess = () => {
  return {
    type: SUBMIT_VERIFICATION_CODE_SUCCESS,
  };
};

const fetchGbpLocationVerificationMethodsSuccess = (methods) => {
  return {
    type: GBP_LOCATION_VERIFICATION_METHOD_SUCCESS,
    payload: methods,
  };
};

const fetchGbpSearchLocationsSuccess = (locations) => {
  return {
    type: GBP_SEARCH_LOCATIONS_SUCCESS,
    payload: locations,
  };
};

const gbpAsyncSuccess = () => {
  return {
    type: GBP_ASYNC_SUCCESS,
  };
};

const createGbpLocationSuccess = (createdLocation) => {
  return {
    type: GBP_CREATE_LOCATION_SUCCESS,
    payload: createdLocation,
  };
}; 

/**
 * Set location data
 * @param {Object} param0 location object
 * @returns action
 */
export const setGbpLocationData = ({
  profile,
  languageCode,
  title,
  regionCode,
  postalCode,
  administrativeArea,
  locality,
  streetAddress,
  primaryCategoryId,
  primaryPhone,
  latitude,
  longitude,
  locationId,
}) => ({
  type: GBP_SET_LOCATION_DATA,
  payload: {
    profile,
    languageCode: languageCode || 'en',
    title,
    regionCode: regionCode || 'US',
    postalCode,
    administrativeArea,
    locality,
    streetAddress,
    primaryCategoryId: primaryCategoryId || null,
    primaryPhone,
    latitude: latitude || null,
    longitude: longitude || null,
    locationId: locationId || null
  }
});

/**
 * Change location property
 * @param {String} key location field
 * @param {String} value location field value
 * @returns action
 */
export const changeGbpLocationData = (key, value) => {
  if ([
    GBP_PROPERTIES.BUSINESS_TITLE,
    GBP_PROPERTIES.CATEGORY,
    GBP_PROPERTIES.CITY,
    GBP_PROPERTIES.PHONE_NUMBER,
    GBP_PROPERTIES.POSTAL_CODE,
    GBP_PROPERTIES.PROFILE_DESCRIPTION,
    GBP_PROPERTIES.STATE,
    GBP_PROPERTIES.STREET_ADDRESS
  ].includes(key)) {
    return {
      type: GBP_CHANGE_LOCATION_DATA,
      payload: { key, value }
    }
  }
}

export const resetGbpLocation = () => ({
  type: GBP_RESET_LOCATION,
});

const fetchGbpUserLocationsSuccess = (locations) => {
  return {
    type: GBP_USER_LOCATIONS_SUCCESS,
    payload: locations,
  };
};

/**
 * Create and store access stoken
 * @param {String} code google code grant
 * @param {boolean} isVettedToken is direct verification token
 * @returns action creator
 */
export function createAccessToken(code, isVettedToken=false) {
  return (dispatch, getState) => {
    const currentBrand = getCurrentUserBrand(getState());

    dispatch(gbpAsyncStart());
    return api.request('gbp/createToken', 'post', null, null, null, { code, isVettedToken })
      .then(() => {
        dispatch(gbpAsyncSuccess());
        if (isVettedToken) {
          dispatch(setGbpSuccessAlertVisibility(true));
        } else {
          dispatch(updateBrandProperty({
            brandId: currentBrand.get('id'),
            propertyType: BRAND_PROPERTY.GBP_PROPERTY_TYPE,
            propertyKey: BRAND_PROPERTY.GBP_VERIFICATION_STATUS,
            propertyValue: GBP_VERIFICATION_STATUS.IN_PROGRESS,
          }));
          dispatch(setGbpAuthSuccess()); // Opens GBP Search Modal after Google Authentication
        }
      })
      .catch(err => {
        dispatch(gbpAsyncErrorReset(err && err.message));
        throw err;
      });
  };
}

/**
 * fetch google locations search results
 * @param {String} keyword search string
 */
export const getGbpSearchLocations = keyword => {
  return (dispatch) => {
    dispatch(gbpAsyncSearchStart());
    return api.request(`gbp/locations?name=${ keyword }`, 'get', null)
      .then(data => {
        dispatch(fetchGbpSearchLocationsSuccess(data.googleLocations));
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncErrorReset(err && err.message))
      });
  };
};

/**
 * Set modal visibility
 * @param {Boolean} isVisible should the modal be visible
 * @param {Number} step page number
 * @param {Boolean} clearErrors should clear errors
 */
export const setModalVisibility = (isVisible, step = GBP_STEPS.OVERVIEW, clearErrors = false) => ({
  type: GBP_SET_MODAL_VISIBILITY,
  payload: { isVisible, step, clearErrors },
});

/**
 * fetch users google locations
 * 
 */
export const getGbpUserLocations = () => {
  return (dispatch) => {
    dispatch(gbpUserLocationAsyncStart());
    return api.request(`gbp/locations?isUserLocation=true`, 'get')
      .then((data) => {
        const userLocations = data && data.locations && data.locations.length ?
          data.locations.map(userLocation => {
            return {
              location: {
                title: userLocation.title,
                latlng: userLocation.latlng,
                storefrontAddress: userLocation.storefrontAddress,
                phoneNumbers: userLocation.phoneNumbers,
                primaryCategoryId: userLocation.categories.primaryCategory.name,
                primaryCategoryName: userLocation.categories.primaryCategory.displayName,
                profile: userLocation.profile ? userLocation.profile.description : null,
                locationId: userLocation.name
              },
              name: userLocation.name,
            };
          }) :
          [];

        dispatch(fetchGbpUserLocationsSuccess(userLocations));
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpUserLocationAsyncError(err && err.message))
      });
  };
};

/**
 * fetch verification status of users google location
 * 
 */
 export const getGbpLocationVerificationStatus = (locId) => {
  return (dispatch) => {
    dispatch(gbpLocationVerificationAsyncStart());
    return api.request(`gbp/locations/${locId}/verification-status`, 'get')
      .then((data) => {
        dispatch(gbpAsyncSuccess());
       return data
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncError(err && err.message))
      });
  };
};

/**
 * Set authenticated state on gbp
 * @returns action
 */
export const setGbpAuthSuccess = () => ({
  type: GBP_AUTH_SUCCESS,
});

/**
 * Revoke gbp token and brand-property on session-error
 * @param {Boolean} isVisible is error visible
 * @param {Boolean} isModalOpen is gbp modal open
 * @returns 
 */
export const onGbpSessionError = (isVisible, isModalOpen) => {
  return (dispatch, getState) => {
    const currentBrand = getCurrentUserBrand(getState());
    dispatch(setGbpAlertVisibility(isVisible, isModalOpen)); // setting up the error modal

    return api.request(`gbp/revokeToken`, 'delete')
      .then(() => {
        dispatch(updateBrandProperty({
          brandId: currentBrand.get('id'),
          propertyType: BRAND_PROPERTY.GBP_PROPERTY_TYPE,
          propertyKey: BRAND_PROPERTY.GBP_VERIFICATION_STATUS,
          propertyValue: GBP_VERIFICATION_STATUS.LOGGED_OUT,
        }));
      })
      .catch(err => {
        console.error('revokeToken error:', err);
      });
  };
};

export const setGbpAlertVisibility = (isVisible, isModalOpen) => ({
  type: GBP_ALERT_VISIBILITY,
  payload: { isVisible, isModalOpen },
});

export const setGbpSuccessAlertVisibility = (isVisible, isLinkLocation = false) => ({
  type: GBP_SUCCESS_ALERT,
  payload: { isVisible, isLinkLocation },
});

export const setGbpFailureAlertVisibility = (isVisible, isLinkLocation = false) => ({
  type: GBP_FAILURE_ALERT,
  payload: { isVisible, isLinkLocation },
});

/**
 * fetch google categories search results
 */
export const getCategories = () => {
  return (dispatch) => {
    dispatch(gbpAsyncStart());
    return api.request(`gbp/categories`, 'get')
      .then(data => {
        dispatch(gbpAsyncSuccess());
        return data;
      }).catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncErrorReset(err && err.message))
      });
  }
}


/**
 * create and verify google location
 * @param {Object} gbpLocation request body
 * @param {boolean} isUserCreated is the location already created by the user
 * @param {Boolean} isNewLocationCreation is the user creating a new Google location (rather than claiming one that already exists)
 */
export const createLocation = (gbpLocation, isLocationCreated, isNewLocationCreation) => {
  return (dispatch, getState) => {
    const currentBrand = getCurrentUserBrand(getState());

    dispatch(gbpAsyncStart());
    return api.request(`gbp/locations?isLocationCreated=${isLocationCreated}&isNewLocationCreation=${isNewLocationCreation}`, 'post', gbpLocation)
      .then(data => {
        dispatch(createGbpLocationSuccess(data));
        return data.googleLocationId;
      }).catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncErrorReset(err && err.message));
        throw err;
      });
  }
}


/**
 * link already verified location
 * @param {String} googleLocationId 
 * @param {Object} gbpLocationData
 */
export const linkLocation = (googleLocationId, gbpLocationData) => {
  return (dispatch, getState) => {
    const currentBrand = getCurrentUserBrand(getState());

    dispatch(gbpAsyncStart());
    return api.request(`gbp/linkLocation?googleLocationId=${googleLocationId}`, 'post', gbpLocationData)
      .then(() => {
        dispatch(gbpAsyncSuccess());
        dispatch(updateBrandProperty({
          brandId: currentBrand.get('id'),
          propertyType: BRAND_PROPERTY.GBP_PROPERTY_TYPE,
          propertyKey: BRAND_PROPERTY.GBP_VERIFICATION_STATUS,
          propertyValue: GBP_VERIFICATION_STATUS.VERIFIED,
        }));
        dispatch(setModalVisibility(true, GBP_STEPS.SUCCESS));
        dispatch(setGbpSuccessAlertVisibility(true, true));
        dispatch(fetchNotificationsAsync());
      }).catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncErrorReset(err && err.message));
        dispatch(setModalVisibility(false));
        dispatch(setGbpFailureAlertVisibility(true, true));
      });
  }
}

/**
 * fetch verification methods of the google location
 * @param {String} locationId
 */
export const getGbpLocationVerificationMethods = locationId => {
  return (dispatch) => {
    dispatch(gbpLocationVerificationMethodsAsyncStart());
    return api.request(`gbp/locations/${locationId}/verificationOptions`, 'get')
      .then(data => {
        dispatch(fetchGbpLocationVerificationMethodsSuccess(data.options));
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpLocationVerificationMethodsAsyncError(err && err.message))
      });
  };
};

/**
 * update location data with gbp
 * @param {Object} gbpUpdateData gbp update location data
 * @returns action creator
 */
export const updateGbpLocationData = gbpUpdateData => {
  return (dispatch) => {
    dispatch(gbpAsyncStart());
    return api.request('gbp/locations', 'put', gbpUpdateData)
      .then(() => {
        dispatch(gbpAsyncSuccess());
        return gbpUpdateData;
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncErrorReset(err && err.message));
        throw err;
      });
  };
};

/**
 * initiate verification process
 *
 * @param {String} locationId
 * @param {Object} requestBody
 * @returns verification process entity
 */
export const initiateGbpVerificationProcess = (locationId, requestBody) => {
  return (dispatch) => {
    dispatch(initiateGbpVerificationProcessAsyncStart());
    return api.request(`gbp/verificationProcess?googleLocationId=${locationId}`, 'post', requestBody)
      .then(data => {
        dispatch(initiateGbpVerificationProcessSuccess(data));
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(initiateGbpVerificationProcessAsyncError(err && PIN_GENERATION_FAILURE));
      });
  };
};

/**
 * submit verification code
 *
 * @param {boolean} isNewLocationCreation is the user creating a new Google location (rather than claiming one that already exists)
 * @param {Object} requestBody
 * @returns
 */
export const submitGbpVerificationCode = (isNewLocationCreation, requestBody) => {
  return (dispatch, getState) => {
    const currentBrand = getCurrentUserBrand(getState());
    dispatch(submitVerificationCodeAsyncStart());

    return api.request(`gbp/verificationProcess/pinSubmission?isNewLocationCreation=${isNewLocationCreation}`, 'post', requestBody)
      .then(() => {
        dispatch(submitVerificationCodeSuccess());
        dispatch(updateBrandProperty({
          brandId: currentBrand.get('id'),
          propertyType: BRAND_PROPERTY.GBP_PROPERTY_TYPE,
          propertyKey: BRAND_PROPERTY.GBP_VERIFICATION_STATUS,
          propertyValue: GBP_VERIFICATION_STATUS.VERIFIED,
        }));
        dispatch(setModalVisibility(true, GBP_STEPS.SUCCESS));
        dispatch(setGbpSuccessAlertVisibility(true, false));
      })
      .catch(err => {
        console.error('Error:', err);
        dispatch(gbpAsyncError(err && err.message));
        throw err;
      });
  };
};